import _ from "lodash";
import { useEffect, useState } from "react";
import FiltersTemplate from "../../components/FiltersTemplate";
import useFetch from "../../utils/useFetch";
import axios from "../../utils/fvAxios";

const tabDefinitions = [
  {
    id: 0,
    text: "Filters",
    fields: [
      {
        id: "biddingIds",
        label: "Bidding Interest",
        inputType: "select",
        multiple: true,
        optionsKey: "biddingIntrests",
      },
      {
        id: "claycoBiddingIds",
        label: "Clayco Bidding Interest",
        inputType: "select",
        multiple: true,
        optionsKey: "claycoBiddingIntrests",
      },
      {
        id: "proficiencyIds",
        label: "Proficiency & Capabilities",
        inputType: "select",
        multiple: true,
        optionsKey: "clientProfiencyCapabilities",
      },
      {
        id: "statusIds",
        label: "Status",
        inputType: "select",
        multiple: true,
        optionsKey: "statusList",
      },
      {
        id: "clientContractId",
        label: "Contractor/Supplier Type",
        inputType: "select",
        optionsKey: "contractorsOrSuppliers",
      },
      {
        id: "productCategories",
        label: "Product Categories",
        inputType: "select",
        multiple: true,
        optionsKey: "productCategories",
      },
      {
        id: "clientVendorRefId",
        label: "Vendor ID",
        inputType: "text",
        optionsKey: "statusList",
      },
    ],
  },
  {
    id: 1,
    text: "Additional Filters",
    fields: [
      {
        id: "site",
        label: "Business Units",
        inputType: "select",
        multiple: true,
        optionsKey: "bUnits",
      },
      {
        id: "subSite",
        label: "Locations/Sites",
        inputType: "select",
        multiple: true,
        optionsKey: "subSite",
      },
      {
        id: "countryName",
        label: "Vendor Country",
        inputType: "select",
        optionsKey: "countries",
      },
      {
        id: "vendorStateName",
        label: "Vendor State",
        inputType: "select",
        optionsKey: "vendorStateName",
      },
      { id: "vendorCityName", label: "Vendor City", inputType: "text" },
      {
        id: "geographicAreas",
        label: "Vendor Operating Region",
        inputType: "select",
        optionsKey: "regions",
      },
      {
        id: "clientTemplateId",
        label: "Risk Level",
        inputType: "select",
        optionsKey: "templates",
      },
    ],
  },
];


function optionsDataMapper({ key, value }) {
  return {
    value: key,
    text: value,
  };
}

export default function ({
  miscFilterOptions = {},
  optionsUrl,
  filterObj,
  CId,
  ClosePo,
  ID,
  ...props
}) {

  const {
    data: resp,
    loading,
    error,
  } = useFetch(optionsUrl, "acceptCachedResponse");

  const [tabs, setTabs] = useState([]);

  function filterChangeHandler(selections) {
    props.filterChangeHandler?.(selections);
  }

  const [keyValuePairs, setKeyValuePairs] = useState([{}]);
  const [activeTab, setActiveTab] = useState(0);
  const GetList = async (e) => {
    const loctabs = _.cloneDeep(tabs);
    var field = loctabs[1].fields.find(r => r.optionsKey == "vendorStateName");
    // if (e == null) {
    //   if (field.optionsKey == "vendorStateName") {
    //     field.hidden = true;
    //     field.options = [];
    //   }
    // } else {
    const res = await axios.get("Common/GetCountryStatesByClientId?clientID=0&country=" + e);
    if (field.optionsKey == "vendorStateName") {
      field.hidden = e == null ? true : false;
      field.options = e == null ? [] : res?.data?.data?.map(
        optionsDataMapper
      );
    }
    // }
    setTabs(loctabs);
    // setStatesList(res?.data?.data);
    setActiveTab(1);
  }



  const GetUnitsList = async (data) => {
    const loctabs = _.cloneDeep(tabs);
    var field = loctabs[1].fields.find(r => r.optionsKey == "subSite");
    if (data == null) {
      if (field.optionsKey == "subSite") {
        field.hidden = true;
        field.options = [];
      }
    } else {
      await axios
        .get("Client/GetBusinessUnitSiteDetails?buSiteIds=" + data)
        .then((resp) => {
          let Site = resp?.data?.data;
          if (resp?.data?.data) {
            Site?.unshift({ businessUnitSiteId: "Any", isChecked: null, isSelected: null, siteName: "Any" });
          }
          // const loctabs = _.cloneDeep(tabs);
          // var field = loctabs[1].fields.find(r => r.optionsKey == "subSite");
          if (field.optionsKey == "subSite") {
            field.hidden = false;
            field.options = Site?.map((busites) => {
              return {
                value: busites?.businessUnitSiteId.toString(),
                text: busites?.siteName,
              };
            });
          }

        })
        .catch((err) => {
          console.error(err);
        });
    }
    setTabs(loctabs);
    setActiveTab(1);

  };

  useEffect(() => {
    const data = resp?.data;
    if (data) {
      setTabs((prev) => {
        const tabs = _.cloneDeep(tabDefinitions);
        return tabs
          .map((tab) => {
            tab.fields.forEach((field) => {
              if (!field.optionsKey) return;

              if (field.optionsKey == "templates" || field.optionsKey == "bUnits") {
                let List = data[field.optionsKey]?.item2;
                if (List?.filter(r => r.key == "Any")?.length == 0)
                  List?.unshift({ key: "Any", value: "Any" });
                field.options = List?.map(optionsDataMapper);
              }

              if (field.optionsKey == "contractorsOrSuppliers") {
                let List = data[field.optionsKey]?.item2;
                if (List?.filter(r => r.key == "None").length == 0)
                  List?.unshift({ key: "None", value: "None" });
                field.options = List?.map(optionsDataMapper);
              }

              if (field.optionsKey == "regions") {
                let List = miscFilterOptions[field.optionsKey]?.item2;
                if (List?.filter(r => r.value == "Any").length == 0)
                  List?.unshift({ key: " ", value: "Any" });
                field.options = List?.map(optionsDataMapper);
              }

              if (field.optionsKey == "clientProfiencyCapabilities") {
                //Proficiancy capabulity will have headding in select
                field.options = [];
                for (let i = 0; i < data[field.optionsKey].item2.length; i++) {
                  field.options.push({ headding: data[field.optionsKey].item2[i].key });
                  for (let j = 0; j < data[field.optionsKey].item2[i].group.length; j++) {
                    field.options.push({ text: data[field.optionsKey].item2[i].group[j].value, value: data[field.optionsKey].item2[i].group[j].key });
                  }
                }
              }
              else
                if (data[field.optionsKey]) {
                  field.options =
                    data[field.optionsKey].item2?.map(optionsDataMapper);
                } else if (miscFilterOptions[field.optionsKey]) {
                  field.options =
                    miscFilterOptions[field.optionsKey].item2?.map(
                      optionsDataMapper
                    );
                } else
                  field.hidden = field.options?.length ? false : true
            });
            tab.fields.forEach(r => r.hidden = !(r.options?.length));
            //tab.fields = tab.fields.filter((field) => field.options?.length);
            return tab;
          })
          .filter((tab) => tab.fields?.length);
      });
    }
  }, [resp]);


  return (
    <FiltersTemplate
      isLoading={loading}
      error={error}
      tabs={tabs}
      filterChangeHandler={filterChangeHandler}
      filterObj={filterObj}
      AdditionalList={GetList}
      BuSites={GetUnitsList}
      CloseFilter={ClosePo}
      activeTab={activeTab}
      ID={ID}
    />
  );
}
